import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "payment-master",
  "use": "payment-master-usage",
  "viewBox": "0 0 74 46",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 74 46\" id=\"payment-master\"><path d=\"M29 23.07a21.73 21.73 0 0 0 8.25 17.07A21.75 21.75 0 0 0 37.31 6h-.05A21.68 21.68 0 0 0 29 23.07z\" fill=\"#ff5f00\" /><path d=\"M37.25 40.14A21.78 21.78 0 0 1 37.26 6a21.72 21.72 0 1 0 0 34.15z\" fill=\"#eb001b\" /><path d=\"M67.59 9.51a21.6 21.6 0 0 0-30.35-3.57l.07.06a21.75 21.75 0 0 1-.06 34.14 21.61 21.61 0 0 0 35-17.08 21.58 21.58 0 0 0-4.66-13.55z\" fill=\"#f79e1b\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol